import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/sections/HeroSection';
import { WhatIsMeeloSection } from '../components/sections/WhatIsMeeloSection';
import { DashboardSection } from '../components/sections/DashboardSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { SocialProofSection } from '../components/sections/SocialProofSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { Footer } from '../components/Footer';
// Thin gradient divider between sections
function SectionDivider({
  variant = 'line'
}: {
  variant?: 'line' | 'glow';
}) {
  if (variant === 'glow') {
    return <div aria-hidden="true" style={{
      height: 1,
      background: 'transparent',
      position: 'relative',
      overflow: 'visible'
    }} data-id="element-220">
        <div style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '60%',
        height: 40,
        background: 'radial-gradient(ellipse at center, rgba(124,77,255,0.10) 0%, transparent 70%)',
        pointerEvents: 'none'
      }} data-id="element-221" />
      </div>;
  }
  return <div aria-hidden="true" style={{
    height: 1,
    margin: '0 auto',
    width: '80%',
    background: 'linear-gradient(90deg, transparent 0%, rgba(124,77,255,0.15) 30%, rgba(124,77,255,0.25) 50%, rgba(124,77,255,0.15) 70%, transparent 100%)'
  }} data-id="element-222" />;
}
export function LandingPage() {
  // Section scroll-reveal: observe all <section> elements
  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = document.querySelectorAll('main > .section-wrap');
    if (prefersReduced) {
      sections.forEach(el => el.classList.add('section-visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('section-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.06
    });
    sections.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans text-gray-900" data-id="element-223">
      <Navbar data-id="element-224" />
      <main data-id="element-225">
        {/* Hero — no reveal wrapper, always visible */}
        <HeroSection data-id="element-226" />

        <SectionDivider variant="glow" data-id="element-227" />
        <div className="section-wrap" data-id="element-228">
          <WhatIsMeeloSection data-id="element-229" />
        </div>

        <SectionDivider variant="line" data-id="element-230" />
        <div className="section-wrap" data-id="element-231">
          <DashboardSection data-id="element-232" />
        </div>

        <SectionDivider variant="glow" data-id="element-233" />
        <div className="section-wrap" data-id="element-234">
          <SolutionSection data-id="element-235" />
        </div>

        <SectionDivider variant="line" data-id="element-236" />
        <div className="section-wrap" data-id="element-237">
          <ResultsSection data-id="element-238" />
        </div>

        <SectionDivider variant="glow" data-id="element-239" />
        <div className="section-wrap" data-id="element-240">
          <SocialProofSection data-id="element-241" />
        </div>

        <SectionDivider variant="line" data-id="element-242" />
        <div className="section-wrap" data-id="element-243">
          <FinalCTASection data-id="element-244" />
        </div>
      </main>
      <Footer data-id="element-245" />
    </div>;
}